import { EXPRESS_API } from 'configs/api/expressApi';
import { IQuickVideo, IUpsertQuickVideoBody } from './types';
import { useMutation, useQueryClient } from 'react-query';
import { quickVideoKeys } from './quickVideoKeys';
import { useToastError } from 'lib/hooks';
import { successToast } from 'lib/components/toasts/success';
import { useTranslation } from 'react-i18next';

interface IEditQuickVideo extends IUpsertQuickVideoBody {
  quickVideoId: number;
}

const editQuickVideo = async (body: IEditQuickVideo) => {
  return (await EXPRESS_API.put(`quick-videos/${body.quickVideoId}`, body))
    .data as IQuickVideo;
};

export const useEditQuickVideoMutation = ({
  quickVideoId,
  onSuccess,
}: {
  quickVideoId: number;
  onSuccess?: () => void;
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(editQuickVideo, {
    onError: error => {
      showError(error);
    },
    onSuccess: async () => {
      // close modal, invalidate queries
      successToast({ title: t('Quick Video successfully updated.') });
      queryClient.invalidateQueries(quickVideoKeys.all());
      queryClient.invalidateQueries(quickVideoKeys.single(quickVideoId));
      if (onSuccess) {
        onSuccess();
      }
    },
  });
};
